module.exports = __webpack_public_path__ + "img/3b9faee.webp";